import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { faqs } from "@/data/faqs";
import { FAQ } from "@/constants/testIds";

export default function FAQSection() {
  return (
    <section id="faq" data-testid={FAQ.section} className="py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-6 md:px-10 lg:px-14">
        <div className="text-center max-w-2xl mx-auto">
          <span className="eyebrow">FAQ</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-3 leading-[1.05]">
            Questions, quickly answered
          </h2>
        </div>

        <div className="mt-12">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={FAQ.item(i)}
                className="border border-black/5 rounded-2xl bg-white px-5 md:px-6"
              >
                <AccordionTrigger className="font-display text-lg md:text-xl text-left hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="font-body text-[var(--aura-charcoal-2)] leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
